import api from "../../utils/api";

// ================= NORMAL LOGIN =================
export const loginUser = async (email, password) => {
  const res = await api.post("/client/user/login", {
    identity: email,
    loginType: 4,
    email: email.trim(),
    password: password.trim(),
    fcmToken: "web_dummy_fcm_token_123456",
  });

  return res.data;
};

// ================= REGISTER =================
export const registerUser = async (email, password) => {
  const res = await api.post("/client/user/login", {
    identity: email,
    loginType: 4,
    email: email.trim(),
    password: password.trim(),
    fcmToken: "web_dummy_fcm_token_123456",
  });

  return res.data;
};

// ================= GOOGLE LOGIN =================
export const googleLoginUser = async ({ email, identity }) => {
  const res = await api.post("/client/user/login", {
    identity: identity,      // firebase uid
    loginType: 2,            // MUST match Flutter
    email: email,
    fcmToken: "web_dummy_fcm_token_123456",
  });

  return res.data;
};
